export default {
  userToken: "auth_token",
  username: "username",
};
